<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="terms-of-service" />
  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section class="page-content">
        <h1>Terms of Service</h1>
        
        <h2>Acceptance of Terms</h2>
        <p>By accessing and using GBWhatsApp website, you accept and agree to be bound by the terms and provision of this agreement.</p>
        
        <h2>Use License</h2>
        <p>Permission is granted to temporarily download one copy of the materials on GBWhatsApp's website for personal, non-commercial transitory viewing only.</p>
        
        <h2>Disclaimer</h2>
        <p>The materials on GBWhatsApp's website are provided "as is". GBWhatsApp makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties.</p>
        
        <h2>Limitations</h2>
        <p>GBWhatsApp shall not be liable for any damages arising out of the use or inability to use the materials on GBWhatsApp's website.</p>
        
        <h2>Governing Law</h2>
        <p>These terms and conditions are governed by and construed in accordance with applicable laws.</p>
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'TermsOfService',
  components: { HeadNav },
};
</script>

<style lang="scss" scoped>
.page-content {
  max-width: 1080px;
  margin: 2rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  h1 { color: #25D366; font-size: 2.5em; margin-bottom: 30px; }
  h2 { color: #25D366; font-size: 1.8em; margin: 30px 0 20px; }
  p { line-height: 1.8; font-size: 16px; color: #444; word-break: break-word; }
}

@media (max-width: 768px) {
  .page-content {
    padding: 20px 15px;
    h1 { font-size: 2em; }
    h2 { font-size: 1.4em; }
    p { font-size: 15px; }
  }
}
</style>
